var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other entry modules.
(() => {
window.VjsUtility = (function(my){
    var self = my.Controller = {};

    self.extend = function(extendProperties){
        return window.VjsUtility.extend(self.Controller, extendProperties);
    }

    self.Controller = function() {};
    self.Controller.prototype = {
        /**
         *  @desc events object to be set when class is instantiated
         */
        events: {
            //example of click event
            //"click .some-class": "callThisCustomFunction"
        },
        //callThisCustomFunction: function(){}     -- add a function to be called when event triggered

        _construct: function() {
            this._setEvents();
        },
        _setEvents: function() {
            var s,
                events = this.events,
                that = this;
            for (var items in events) {
                s = items.split(" ");

                if (s[0] === "scroll") {
                    $(window).off(s[0]);
                    $(window).on(s[0], { items: events[items], that: this }, function(e) {
                        //Passing Context
                        var that = e.data.that;
                        that[e.data.items](e);
                    });
                } else {
                    //Remove the same event before adding another
                    $("body").off(s[0], s[1]);
                    $("body").on(s[0], s[1], { items: events[items], that: this }, function(e) {
                        //Passing Context
                        var that = e.data.that;
                        that[e.data.items](e);
                    });
                }
            }
        }
    };

    return my;
}(window.VjsUtility || {}));

})();

// This entry need to be wrapped in an IIFE because it need to be isolated against other entry modules.
(() => {
window.VjsUtility = (function(my){
    my.extend = function(Parent, extObject){
        function Child() {
            Child.parent.constructor.apply(this, arguments);
            if (typeof this._construct === "function") {
                this._construct(arguments[0]);
            }
        }
        Child.prototype = inherit(Parent.prototype);
        Child.prototype.constructor = Child;
        Child.parent = Parent.prototype;
        Child = extendHelper(Child, extObject);
        return Child;
    }

    function extendHelper(Child, extObject) {
        for (var key in extObject) {
            Child.prototype[key] = extObject[key];
        }
        return Child;
    }

    function inherit(proto) {
        function F() {}
        F.prototype = proto;
        return new F();
    }

    return my;
}(window.VjsUtility || {}));

})();

// This entry need to be wrapped in an IIFE because it need to be isolated against other entry modules.
(() => {
window.VjsUtility = (function(my){
    var self = my.Notification = {};

    var _defaultTime = 1500;
    var _defaultType = "success";
    var _hooks = [];

    /**
     *  @desc initializes most general notification
     *  @param params.text  text for notification
     *  @param params.time  time notification stays visible
     *  @param params.type  type of notification
     */
    self.init = function(params){
        //if params is a string, assume text
        params = (typeof params === "string") ? {text: params } : params;

        //verify text is filled in
        if(!params.text || params.text === ""){
            throw Error("Notification : missing text");
        }

        params.time = params.time ? params.time : _defaultTime;
        params.type = params.type ? params.type : _defaultType;

        _callHooks(
            params.text,
            params.time,
            params.type
        );
    }

    self.success = function(params){
        params = (typeof params === "string") ? {text: params } : params;
        params.type = "success";

        self.init(params);
    }

    self.error = function(params){
        params = (typeof params === "string") ? {text: params } : params;
        params.type = "error";

        self.init(params);
    }

    self.warning = function(params){
        params = (typeof params === "string") ? {text: params } : params;
        params.type = "warning";

        self.init(params);
    }

    self.info = function(params){
        params = (typeof params === "string") ? {text: params } : params;
        params.type = "info";

        self.init(params);
    }

    self.addHook = function(callBack){
        if(typeof callBack !== "function") throw new Error("Notifications : addHook : notification hook must be a function.");
        _hooks.push(callBack);
    }

    self.updateSettings = function(settings){
        if(typeof settings !== "object") throw new Error("Notification : updateSettings : settings must be an object.");

        _defaultTime = settings.time ? settings.time : _defaultTime;
        _defaultType = settings.type ? settings.type : _defaultType;

        //now test for a hook function
        if(settings.hook){
            if(typeof settings.hook !== "function") throw new Error("Notifications : updateSettings : hook was passed but is not a function.");
            _hooks.push(settings.hook);
        }
    }

    function _callHooks(text, time, type){
        _hooks.forEach(function(item){
            item(text, time, type);
        });
    }

    return my;
}(window.VjsUtility || {}));

})();

// This entry need to be wrapped in an IIFE because it need to be isolated against other entry modules.
(() => {
window.VjsUtility = (function(my){
    var self = my.Popup = {};

    //this will hold the instance of the popup
    //this should be like a singleton
    var _popup = null;

    self.init = function (settings) {
        _popup = new Popup();
        _popup.render(settings);
    };

    self.close = function () {
        _popup.close();
    };

    var Popup = function () {};
    Popup.prototype = {
        /**
         *  @desc title of the popup
         */
        title: null,

        /**
         *  @desc content of the popup
         */
        content: null,

        /**
         *  @desc width of the popup
         */
        width: "600px",

        /**
         *  @desc height of the popup
         */
        height: "auto",

        /**
         *  @desc transition type for popup
         *      possible values  [fade, slide-right, slide-top]
         */
        transition: "fade",

        /**
         *  @desc id of popup background
         */
        backgroundId: "#vjs-popup-background",

        /**
         *  @desc classes to add to popup background
         */
        backgroundClasses: null,

        /**
         *  @desc id of popup body
         */
        bodyId: "#vjs-popup-body",

        /**
         *  @desc classes to add to the popup body
         */
        bodyClasses: null,

        /**
         *  @desc content container id
         */
        contentId: "#vjs-popup-content",

        /**
         *  @desc which type of icon for the close icon
         *      possible values
         *      fa = font awesome
         *      all other with be an X
         */
        iconType: "fa",

        /**
         *  @desc should we hide the title bar?
         *       true / false
         */
        hideTitle: false,

        //???
        after: null,
        onRender: null,
        onClose: null,

        /**
         *  @desc popup html
         */
        html: {
            background: function () {
                return "<div class='vjs-popup-background " + (this.backgroundClasses ? this.backgroundClasses : "") + "' id='vjs-popup-background'></div>";
            },
            body: function () {
                var titleBar = ''
                    + '<div class="vjs-popup-title-container">'
                    + '	<div class="vjs-popup-title" id="vjs-popup-title"></div>'
                    + '	<div id="vjs-popup-notification" class="vjs-popup-notification"></div>'
                    + '</div>';

                var compiledBody = ""
                    + '<div class="vjs-popup-body ' + (this.transition ? this.transition : '') +  ' '  // add the transition class
                    + (this.bodyClasses ? this.bodyClasses : '') + '" id="vjs-popup-body">'        // add the custom body classes
                    + (this.hideTitle ? '' : titleBar)
                    +   '<div class="vjs-popup-close" id="vjs-popup-close" tabindex="0" aria-label="close popup">' + this.html.icon.call(this) + '</div>'
                    +   '<div class="vjs-popup-content" id="vjs-popup-content"></div>'
                    + "</div>";

                return compiledBody;
            },
            icon: function () {
                switch (this.iconType) {
                    case "fa":
                        return "<i class='fa fa-times vjs-popup-close-icon'></i>";
                    default:
                        return "<span class='vjs-popup-close-icon'>X</span>";
                }
            }
        },

        render: function (settings) {
            //set any settings passed in
            this.title               = settings.title                ? settings.title               : this.title;
            this.content             = settings.content              ? settings.content             : this.content;
            this.width               = settings.width                ? settings.width               : this.width;
            this.height              = settings.height               ? settings.height              : this.height;
            this.transition          = settings.transition           ? settings.transition          : this.transition;
            this.backgroundClasses   = settings.backgroundClasses    ? settings.backgroundClasses   : this.backgroundClasses;
            this.bodyClasses         = settings.bodyClasses          ? settings.bodyClasses         : this.bodyClasses;
            this.iconType            = settings.iconType             ? settings.iconType            : this.iconType;
            this.hideTitle           = settings.hideTitle            ? settings.hideTitle           : this.hideTitle;
            this.after               = settings.after                ? settings.after               : this.after;

            //not using these yet
            //or ever will
            this.onClose             = settings.onClose              ? settings.onClose             : this.onClose;
            this.onRender            = settings.onRender             ? settings.onRender            : this.onRender;

            //test if popup already exists
            this._testIfPopupExists();

            //add the background html to the page
            $("body")
                .addClass("body-stop-scroll")
                .append(this.html.background.call(this));

            // $(".vjs-header-container, .vjs-main-container, .vjs-footer-container").addClass("blur");
            var popup = $(this.html.body.call(this));
            popup.find("#vjs-popup-title").html(this.title);
            popup.find("#vjs-popup-content").html(this.content);
            popup.appendTo(this.backgroundId);

            $(".vjs-popup-close").focus();

            if (typeof this.onRender === "function") {
                this.onRender();
            }

            //now we build the body of the popup using the view class on the utility object

            //possible settings to send
            //  this.settings.url
            //  this.settings.templateUrl
            //  this.settings.data

            var PopupBody = my.View.extend({
                parent: this.contentId,
                templateUrl: (settings.templateUrl)
                                ? settings.templateUrl
                                : null,
                dataUrl:     (settings.dataUrl)
                                ? settings.dataUrl
                                : null,
                events: {
                    "click #vjs-popup-close": "_close",
                    "keyup #vjs-popup-body":  "_keypressClose"
                },
                after: function () {
                    if(typeof this.after === "function") this.after.call(this);
                }.bind(this),
                _close: function () {
                    this.close();
                }.bind(this),
                _keypressClose: function (e) {
                    var keyPressed = (e.keyCode ? e.keyCode : e.which);

                    if (keyPressed == 27) {
                        this.close();
                    }
                }.bind(this)
            });

            //now figure out if we should use the fetch or render function
            var pbody = (new PopupBody());
            if(settings.dataUrl){
                pbody.fetch();
            }else{
                pbody.render(
                    (settings.data ? settings.data : null)
                );
            }
        },

        /**
         *  @desc this will check if popup exists, and if so it will remove it
         *      only one popup allowed at a time
         */
        _testIfPopupExists: function () {
            var $popup = $(this.backgroundId)
            if($popup.is(":visible")){
                $popup.detach().remove();
            }
        },

        close: function (e) {
            //see if need to return focus to another element
            if (this.focusReturn) {
                $(this.focusReturn).focus();
            }

            //see if they have a callback
            if(typeof this.closeCallBack === "function"){
                this.closeCallBack();
            }

            $("body").removeClass("body-stop-scroll");
            $("#vjs-popup-background")
                .fadeOut(function () {
                    $(this).detach().remove();
                });

            if (typeof this.onClose === "function"){
                this.onClose();
            }
        }
    };

    return my;
}(window.VjsUtility || {}));

})();

// This entry need to be wrapped in an IIFE because it need to be isolated against other entry modules.
(() => {
window.VjsUtility = (function(my){
    var self = my.Request = function(){};

    /**
     * @desc parsing function for the success response request
     * @type function
     */
    var successParser = null;

    /**
     * @desc function to set the success parser for the request calls
     * @param sParser {function} success parser function
     */
    self.setParser = function(sParser){
        if (sParser){
            if (typeof sParser !== "function") throw new Error("VjsUtility -> Request -> setParser : invalid success parser type");
            successParser = sParser;
        }
    }

    /**
     * @desc GET request
     * @param url {String} Required
     * @param params {Object}
     */
    self.prototype.get = function(url, params) {
        var $d = $.Deferred();
        $.get(url, params)
            .done(function(res) {
                if(successParser){
                    res = successParser(res);
                }
                $d.resolve(res);
            })
            .fail(function(x, h, r) {
                $d.reject(x, h, r);
            });
        return $d;
    };

    /**
     * @desc POST request
     * @param url {String} Required
     * @param params {Object}
     */
    self.prototype.post = function(url, params) {
        var $d = $.Deferred();
        $.post(url, params)
            .done(function(res) {
                if(successParser){
                    res = successParser(res);
                }
                $d.resolve(res);
            })
            .fail(function(x, h, r) {
                $d.reject(x, h, r);
            });
        return $d;
    };

    /**
     * @desc PUT request
     * @param url {String} Required
     * @param params {Object}
     */
    self.prototype.put = function(url, params) {
        if (typeof params !== "object") {
            params = { _METHOD: "PUT" };
        } else {
            params["_METHOD"] = "PUT";
        }
        var $d = $.Deferred();
        $.post(url, params)
            .done(function(res) {
                if(successParser){
                    res = successParser(res);
                }
                $d.resolve(res);
            })
            .fail(function(x, h, r) {
                $d.reject(x, h, r);
            });
        return $d;
    };

    /**
     * @desc DELETE request
     * @param url {String} Required
     * @param params {Object}
     */
    self.prototype.delete = function(url, params) {
        if (typeof params !== "object") {
            params = { _METHOD: "DELETE" };
        } else {
            params["_METHOD"] = "DELETE";
        }
        var $d = $.Deferred();
        $.post(url, params)
            .done(function(res) {
                if(successParser){
                    res = successParser(res);
                }
                $d.resolve(res);
            })
            .fail(function(x, h, r) {
                $d.reject(x, h, r);
            });
        return $d;
    };

    return my;
}(window.VjsUtility || {}));

})();

// This entry need to be wrapped in an IIFE because it need to be isolated against other entry modules.
(() => {
window.VjsUtility = (function(my){
    var self = my.View = {},
        TEMPLATE_BASE_URL = null,
        TEMPLATE_VERSION = Math.random();

    self.setTemplateBaseUrl = function(baseUrl){
        TEMPLATE_BASE_URL = baseUrl;
    }

    self.setTemplateVersion = function(version){
        TEMPLATE_VERSION = version;
    }

    self.extend = function(extendProperties){
        return VjsUtility.extend(self.View, extendProperties);
    }

    self.View = function() {};
    self.View.prototype = {
        /**
         *   @desc main endpoint for api data
         *   @type string or function that returns string
         */
        dataUrl: null,

        /**
         *  @desc params used in fetch call
         *  @type object
         */
        fetchParams: null,

        /**
         *  @desc fetch type used GET or POST
         *  @type string
         */
        fetchType: null,

        /**
         *  @desc responose data from the fetch call, after being parsed
         */
        responseData: null,

        /**
         *  @desc responose data from the fetch call, before being parsed
         */
        originalResponseData: null,

        /**
         *   @desc the id or class of the parent html element that view should go into
         *   should be overridden if used. Only here as reminder
         */
        parent: null, // Should be Overridden

        /**
         *   @desc insert type describes how to add items to the dom
         *       defaults to html, but can use append or prepend
         */
        insertType: "html",  //html, prepend, append

        /**
         *   @desc base url to the templates folder.
         *   @type string
         */
        templateBaseUrl: function(){
            return TEMPLATE_BASE_URL ? TEMPLATE_BASE_URL : "";
        },

        /**
         *   @desc url of the handlebars template
         *   @type string or function that returns string
         */
        templateUrl: null,

        /**
         *   @desc template versioning to be sure ajax gets new template
         *   @type string or int
         */
        templateVersion: function(){
            return TEMPLATE_VERSION;
        },

        /**
         *  @desc overwritable function inorder to parse the api response data
         *  @type function
         *  @return parsed data to be passed to template
         *  @param $data mixed
         */
        parse: null,

        /**
         *  @desc function called before the template is rendered
         *      and html is available in the DOM
         *      returning data does nothiing
         */
        before: null,

        /**
         *  @desc function called after template is rendered
         *      and html is available in the DOM
         *      returning data does nothing
         */
        after: null,

        /**
         *  @desc events object to be set when class is instantiated
         */
        events: {
            //example of click event
            //"click .some-class": "callThisCustomFunction"

        },
        //callThisCustomFunction: function(){}     -- add a function to be called when event triggered

        /**
         *   @desc fetches model data
         *   @param objParam - (optional) parameters of the data call
         *   @param type - (optional) what type of ajax call. defaults to get
         */
        fetch: function(objParam, type) {
            this.fetchParams = objParam;
            this.fetchType = type;
            if ((this.fetchType+"").toLowerCase() === "post") {
                $.post(this._buildUrl(), objParam)
                    .done(this._start.bind(this))
                    .fail(this._fail.bind(this));
            } else{
                var url = this._buildUrl(objParam);
                $.get(url)
                    .done(this._start.bind(this))
                    .fail(this._fail.bind(this));
            }
        },

        render: function(renderData) {
            if(!this.parent) throw new Error("View parent is not set");
            var that = this;

            //Test if responseData has been set
            //render function can be called directly with data
            if (!this.responseData) {
                this.responseData = renderData;
            }

            //Call before fetching and rendering the template
            if(typeof this.before === "function"){
                this.before.call(this, this.responseData);
            }

            //We cache templates on the Handlebars object
            //test if that templates object has been set yet
            Handlebars.templates = Handlebars.templates ? Handlebars.templates : {};

            //get the template Url
            var url = (typeof this.templateUrl === "function") ? this.templateUrl() : this.templateUrl;
            if(!url || url === "") return;

            //Test if Handlers template is cached
            if (Handlebars.templates[url]) {
                //call the rendering function with the compiled template
                this._renderHelper(Handlebars.templates[url]);

            } else{
                //template is not cached
                //fetch the template and pass compiled template to rendering function
                this._fetchTemplate(url, function(compiledTemplate) {
                    this._renderHelper(compiledTemplate);
                }.bind(this));
            }
        },

        /**
         *   @desc returns url with serialized params for different type of calls
         *   @param type - type of call
         *   @param objParam - (optional) parameters to add to url
         *   @return final url
         */
        _buildUrl: function(objParam) {
            var url = typeof this.dataUrl === "function" ? this.dataUrl.call(this) : this.dataUrl;
            return url + "?" + $.param(objParam || {});
        },

        /**
         *   @desc generic fail function for the ajax functions
         *   should be overridden if need custom failure handling
         */
        _fail: function(x, h, r) {
            console.log(x,h,r);
        },

        _start: function(data) {
            this.originalResponseData = data;
            this.responseData = (typeof this.parse === "function") ? this.parse(this.originalResponseData) : this.originalResponseData;
            this.render(this.responseData);
        },

        _renderHelper: function(compiledTemplate){
            //test if parent is a string, it will be assumed it is a jquery eligible string
            if (typeof this.parent === "string") {
                $(this.parent)[this.insertType](compiledTemplate({ items: this.responseData }));

            //test if parent is a function, it will assume the response is a jquery eligible string
            } else if(typeof this.parent === "function") {
                $(this.parent())[this.insertType](compiledTemplate({ items: this.responseData }));

            //test if parent is an objecct, it will be assumed {this.parent} is a jquery object
            } else if (typeof this.parent === "object"){
                this.parent[this.insertType](compiledTemplate({ items: this.responseData }));

            //if none then throw an error
            }else{
                throw new Error("View : _renderHelper : Parent element is not correct format.");
            }

            //call the after function with the response data
            //this is the end of the line
            if(typeof this.after === "function"){
                this.after.call(this, this.responseData);
            }
        },

        /**
         *  @desc fetches the template
         */
        _fetchTemplate: function(url, callback){
            var url = url;
            return $.ajax({
                url: ((this.templateBaseUrl) ? this.templateBaseUrl() + url : url ) + "?v=" + this.templateVersion(),
                async: true,
                dataType: "text"
            })
                .done(function(res){
                    //cache the Handlebars template
                    Handlebars.templates[url] = Handlebars.compile(res);

                    //pass compiled template to callback
                    callback(Handlebars.templates[url]);

                }.bind(this))
                .fail(function(x, h, r) {
                    throw new Error("Failed to load template `" + url + "`");
                });
        },

        //same items from controller
        //handles the setting of events
        _construct: function() {
            this._setEvents();
        },
        _setEvents: function() {
            var s,
                events = this.events,
                that = this;
            for (var items in events) {
                s = items.split(" ");

                if (s[0] === "scroll") {
                    $(window).off(s[0]);
                    $(window).on(s[0], { items: events[items], that: this }, function(e) {
                        //Passing Context
                        var that = e.data.that;
                        that[e.data.items](e);
                    });
                } else {
                    //Remove the same event before adding another
                    $("body").off(s[0], s[1]);
                    $("body").on(s[0], s[1], { items: events[items], that: this }, function(e) {
                        //Passing Context
                        var that = e.data.that;
                        that[e.data.items](e);
                    });
                }
            }
        },

        // /**
        //  *   @desc Build popup
        //  */
        // _popup: function(html) {
        // 	new VJS.Popup.init({
        // 		title: this.popupTitle,
        // 		content: html,
        // 		transition: this.transition ? this.transition : "",
        // 		focusReturn: this.focusReturn ? this.focusReturn : null,

        // 	});
        // },

        // /**
        //  *   @desc is Popup
        //  */
        // isPopup: false,

        // /**
        //  *   @desc Popup Title
        //  */
        // popupTitle: "VJS Popup",
    };

    return my;
}(window.VjsUtility || {}));

})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// extracted by mini-css-extract-plugin

})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
// extracted by mini-css-extract-plugin

})();
